


































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { dictServe, performanceServer } from '@/api/installServer';
import SafetyAndEnvironmentDialog from '@/views/inspectionContents/safetyAndEnvironmentAssessment/unit/safetyAndEnvironmentDialog.vue';
import ChoosePersonDialog from '@/views/inventoryManagement/unit/choosePersonDialog.vue';

@Component({
  components: { ChoosePersonDialog, SafetyAndEnvironmentDialog },
})
export default class AssessmentPageComponent extends Vue {
  @Prop(Object) editData!: any; // 传递给编辑页面-数据对象
  @Prop(String) NewType!: any; // 传递给编辑页面-类型

  // 表单数据
  formData: any = {
    name: '',
    year: '',
    dutyMainPoint: '',
    executeDepartmentId: '',
    executeDepartmentName: '',
    executePostIds: '',
    executePostNames: '',
    executeStaffId: '',
    executeStaffName: '',
    id: '',
    spaceId: '',
    list: [],
  };

  isLoading: any = false; // 点击确定之后
  formRules: any = {};
  deptObj: any = {};
  postObj: any = [];
  personObj: any = {};
  index: any = 0;
  taskOptions: any = [];
  subSpaceByAuthOptions: any = [
    {
      value: '固定',
      label: '固定',
    },
    {
      value: '动态',
      label: '动态',
    },
  ];
  private newIndex: any = '';

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    const a: any = new Date().getFullYear();
    this.formData.year = a.toString();
    this.deptObj = {};
    this.postObj = [];
    this.isLoading = false; // 点击确定之后
    this.personObj = {};
    this.getDetailByIdData();
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getDetailByIdData() {
    // 发起接口请求，获取分页数据
    dictServe
      .getDetailsMapByName('frequency')
      .then((res: any) => {
        for (const key in res.data) {
          this.taskOptions.push({
            value: key,
            label: res.data[key],
          }); //属性
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  changeProject(index: any) {
    this.newIndex = index;
    // if (this.formData.assessType) {
    const safetyDialog = 'safetyDialog';
    const safetyDialogComponent = this.$refs[safetyDialog];
    (safetyDialogComponent as any).showDialog(this.formData.assessType); // 传给弹窗的数据 检查标准项(即 检查内容)
    // } else {
    //     this.$message.warning('请先选择考核类型！');
    // }
  }

  choosePersonLiable() {
    const safetyDialog = 'choosePersonDialog';
    const safetyDialogComponent = this.$refs[safetyDialog];
    (safetyDialogComponent as any).showDialog(this.deptObj, this.postObj, this.personObj); // 传给弹窗的数据 检查标准项(即 检查内容)
  }

  /**
   * @desc 检查内容弹窗中所选的数据
   * */
  getData(data: any) {
    if (data) {
      this.formData.list[this.newIndex].assessContent = data.assessContent;
      this.formData.list[this.newIndex].assessStand = data.assessStand;
      this.formData.list[this.newIndex].assessContentId = data.id;
      this.formData.list[this.newIndex].assessProjectName = data.assessProject;
    } else {
      this.formData.list[this.newIndex].assessContent = '';
      this.formData.list[this.newIndex].assessStand = '';
      this.formData.list[this.newIndex].assessContentId = '';
      this.formData.list[this.newIndex].assessProjectName = '';
    }
    this.$forceUpdate();
  }

  /**
   * @desc 检查内容弹窗中所选的数据
   * */
  getPersonData(deptData: any, postData: any, personData: any) {
    this.deptObj = deptData;
    this.postObj = postData;
    this.personObj = personData;
    if (deptData.id && !personData.id) {
      this.formData.executeDepartmentId = deptData.id;
      this.formData.executeDepartmentName = deptData.name;
      this.formData.executeStaffId = '';
      this.formData.executeStaffName = '';
      this.formData.name = deptData.name;
    }
    if (deptData.id && personData.id) {
      this.formData.executeDepartmentId = deptData.id;
      this.formData.executeDepartmentName = deptData.name;
      this.formData.executeStaffId = personData.id;
      this.formData.executeStaffName = personData.name;
      this.formData.name = personData.name;
    }
    if (postData && postData.length > 0) {
      const idList: any = [];
      const nameList: any = [];
      postData.forEach((r: any) => {
        idList.push(r.postId);
        nameList.push(r.postName);
      });
      this.formData.executePostIds = idList.toString();
      this.formData.executePostNames = nameList.toString();
    }
    if (postData && postData.length === 0) {
      this.formData.executePostIds = '';
      this.formData.executePostNames = '';
    }

    this.$forceUpdate();
  }

  private addList() {
    this.index = this.index + 1;
    this.formData.list.unshift({
      // index: this.index,
      assessContent: '',
      assessContentId: '',
      assessProjectName: '',
      assessStand: '',
      dutyContent: '',
      frequency: 0,
      frequencyUnit: '',
      referWeights: 0,
      remark: '',
      type: '',
    });
  }

  private delList(index: any) {
    if (this.formData.list.length === 1) {
      (this as any).$message.warning('至少保留一项');
      return false;
    }
    this.formData.list.splice(index, 1);
  }

  /**
   * @desc 点击取消按钮
   */
  close() {
    this.isLoading = false;
    this.formData = {};
    this.$emit('refreshData');
  }

  /**
   * @desc 点击取消按钮
   */
  saveHazardType() {
    this.isLoading = true;
    this.formData.list.forEach((re: any) => {
      re.frequency = parseInt(re.frequency);
      re.referWeights = parseInt(re.referWeights);
    });
    delete this.formData.name;
    performanceServer
      .addDutyRuleList(this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('添加成功！');
          this.close();
        } else {
          this.isLoading = false;
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        this.isLoading = false;
        this.$message.warning('新增数据失败！');
      });
  }
}
